import React from 'react';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const TimelineTatortSelection = ({selectedTatortId, onChange, locationSelection}) => {
    return (
        <FormControl variant="standard" sx={{minWidth: '10em'}}>
            <InputLabel id="tatort-filter-label">Location</InputLabel>
            <Select
                value={selectedTatortId}
                onChange={e => onChange(e.target.value)}
                labelId="tatort-filter-label"
            >
                {locationSelection.map(tatort => (
                    <MenuItem key={tatort.id}
                              value={tatort.id}>{tatort.text}</MenuItem>))}
            </Select>
        </FormControl>
    )
}

export default TimelineTatortSelection;
